export default "__VITE_ASSET__Bj9OT8sZ__"